/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Source_Details_HintInputs */

const cs_templates_source_details_hint = /** @type {(inputs: Templates_Source_Details_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro pokročilé úpravy. Běžný náhled je nahoře.`)
};

const en_templates_source_details_hint = /** @type {(inputs: Templates_Source_Details_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For advanced edits. Everyday preview is above.`)
};

/**
* | output |
* | --- |
* | "For advanced edits. Everyday preview is above." |
*
* @param {Templates_Source_Details_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_source_details_hint = /** @type {((inputs?: Templates_Source_Details_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Source_Details_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_source_details_hint(inputs)
	return cs_templates_source_details_hint(inputs)
});